import { getEventEmitter } from '@process-advisor/process-miner/processMiner/processMiner';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = {
    status: string,
}

export async function openSaveModal ({ status }:  Props) {
    getEventEmitter().emit(Event.saveModal, {status});
};

